import React from "react";
import { CgProfile } from "react-icons/cg";
import { FaCreditCard, FaLink } from "react-icons/fa";

const SubHeader = ({ userObj, changeScreen, setchangeScreen }) => {
  const activeColor = "#211F59"; // Your specified color

  return (
    <div className="max-w-xl mx-auto flex  justify-center py-2 font-instrument">
      <div className="w-full md:w-2/5 bg-transparent rounded-lg" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>
        <div className="px-4 py-2">
          {/* Credit Banner - Top of header */}
          {userObj?.credit && (
            <div className="text-center mb-2 bg-green-50 py-1 px-3 rounded-md">
              <span className="text-xs text-green-700 font-semibold">
                Referral Earnings: <span className="text-green-800">{userObj?.credit}$</span>
              </span>
            </div>
          )}

          {/* Navigation - Centered with equal spacing */}
          <div className="flex justify-center items-center space-x-3 md:space-x-4 lg:space-x-6">
            <div
              className="flex flex-col md:flex-row items-center px-3 py-1.5 md:px-4 md:py-2 rounded-md cursor-pointer transition-all duration-200"
              onClick={() => setchangeScreen(0)}
              style={{
                color: changeScreen === 0 ? activeColor : '#6B7280',
                fontWeight: changeScreen === 0 ? '600' : '500'
              }}
            >
              <span className={`mb-0.5 md:mb-0 md:mr-1.5 ${changeScreen === 0 ? "text-base md:text-lg" : "text-base md:text-lg"
                }`}>
                <CgProfile style={{
                  color: changeScreen === 0 ? activeColor : '#9CA3AF'
                }} />
              </span>
              <span className="text-xs md:text-sm font-medium">Profile</span>
            </div>

            <div
              className="flex flex-col md:flex-row items-center px-3 py-1.5 md:px-4 md:py-2 rounded-md cursor-pointer transition-all duration-200"
              onClick={() => setchangeScreen(1)}
              style={{
                color: changeScreen === 1 ? activeColor : '#6B7280',
                fontWeight: changeScreen === 1 ? '600' : '500'
              }}
            >
              <span className={`mb-0.5 md:mb-0 md:mr-1.5 ${changeScreen === 1 ? "text-base md:text-lg" : "text-base md:text-lg"
                }`}>
                <FaCreditCard style={{
                  color: changeScreen === 1 ? activeColor : '#9CA3AF'
                }} />
              </span>
              <span className="text-xs md:text-sm font-medium">Payment</span>
            </div>

            <div
              className="flex flex-col md:flex-row items-center px-3 py-1.5 md:px-4 md:py-2 rounded-md cursor-pointer transition-all duration-200"
              onClick={() => setchangeScreen(2)}
              style={{
                color: changeScreen === 2 ? activeColor : '#6B7280',
                fontWeight: changeScreen === 2 ? '600' : '500'
              }}
            >
              <span className={`mb-0.5 md:mb-0 md:mr-1.5 ${changeScreen === 2 ? "text-base md:text-lg" : "text-base md:text-lg"
                }`}>
                <FaLink style={{
                  color: changeScreen === 2 ? activeColor : '#9CA3AF'
                }} />
              </span>
              <span className="text-xs md:text-sm font-medium">Referrals</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubHeader;